import React from "react";
import { Link } from "react-router-dom";

const RulesPage = () => {
  return (
    <div className="info-page">
      <div className="info-page-header">
        <Link to="/" className="back-button">
          ✕
        </Link>

        <h1>Правила клуба 📝</h1>
      </div>

      <div className="info-card">
        <h2 className="info-section-title">
          Правила нашего бильярдного клуба 🩷
        </h2>

        <div className="rule-card">
          <div className="rule-icon">🎱</div>

          <div className="rule-content">
            <h3>Кии и мелки</h3>

            <p>
              Пожалуйста, бери кии только рядом со своим столом, и три их мелком
              цвета, соответствующего цвету сукна. Другой цвет мела оставляет
              следы 💦
            </p>
          </div>
        </div>

        <div className="rule-card">
          <div className="rule-icon">🥤</div>

          <div className="rule-content">
            <h3>Напитки</h3>

            <p>
              Пожалуйста, не ставь напитки на сукно и борты стола, чтобы
              случайно не пролить. За пролитие напитков на стол придётся внести
              3000 руб. взноса за хим. чистку. <br /> (Если интересно, то перетянуть
              новое сукно стоит 45 000 руб.) 💵
            </p>
          </div>
        </div>

        <div className="rule-card">
          <div className="rule-icon">⏰</div>

          <div className="rule-content">
            <h3>Время брони</h3>

            <p>Пожалуйста, приходи во время, столик принадлежит тебе на всё время брони, а другим мы отказываем. Поэтому, если вы пришли позже, стоить он будет соответственно забронированному времени ⏰</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RulesPage;

